import {
  ActionsMenu,
  TableToolbar,
  TableWrapper,
  Tabs,
} from 'melp-design/components';
import { Stack } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useModalContext } from 'store/modal';
import { useRouteParams } from 'utils/useIdParam';
import { ROUTES } from 'config';
import { useMe } from 'state/Administrators';
import { EmployeeWalletBenefits } from './atoms/employee-wallet-benefits.component';
import { ExpensesTable } from './atoms/employee-wallet-expenses.component';
import RecongitionIncomeSummary from './atoms/employee-wallet-recognitions.component';
import { CreateExpenseModal } from './atoms';

const EmployeeWallet = () => {
  const { t } = useTranslation();
  const { openModal } = useModalContext();
  const { id: employeeId } = useRouteParams(ROUTES.employees.details);
  const { hasEditPermission } = useMe();

  const [selectedTab, setSelectedTab] = useState<
    'benefits' | 'recognition' | 'expense'
  >('benefits');

  return (
    <TableWrapper>
      <TableToolbar>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          gap={1}
        >
          <Tabs
            value={selectedTab}
            onChange={(v) => setSelectedTab(v)}
            items={[
              {
                value: 'benefits',
                label: t('wallet.employeeWalletBenefits'),
              },
              {
                value: 'recognition',
                label: t('wallet.employeeWalletRecognition'),
              },
              {
                value: 'expense',
                label: t('employees.reserved'),
              },
            ]}
          />

          <ActionsMenu
            type="spread"
            items={[
              {
                label: t('benefitExpenses.addExpense'),
                color: 'primary',
                disabled: !hasEditPermission(['expenses']),
                onClick: () => {
                  openModal({
                    component: CreateExpenseModal,
                    props: { employeeId },
                    size: 'lg',
                  });
                },
              },
            ]}
          />
        </Stack>
      </TableToolbar>

      {selectedTab === 'benefits' && <EmployeeWalletBenefits />}
      {selectedTab === 'recognition' && <RecongitionIncomeSummary />}
      {selectedTab === 'expense' && <ExpensesTable />}
    </TableWrapper>
  );
};

export default EmployeeWallet;
